import styled from "styled-components";

export const Container = styled.div`
  max-width: 720px;
  margin: auto;
  h2 {
    text-align: center;
  }
  p {
    margin: 20px 0;
  }
`;
